/**
 * Estado puro dos alertas "provedor de IA sem crédito" (sem React).
 */
export const PROVIDER_PANEL_URLS = Object.freeze({
  openai: "https://platform.openai.com/settings/organization/billing/overview",
  grok: "https://console.x.ai/",
  xai: "https://console.x.ai/",
  claude: "https://console.anthropic.com/settings/billing",
  anthropic: "https://console.anthropic.com/settings/billing",
  gemini: "https://aistudio.google.com/",
  google: "https://aistudio.google.com/",
});

export function providerPanelUrl(provider) {
  return PROVIDER_PANEL_URLS[String(provider || "").toLowerCase()] || null;
}

const toNum = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

function normalizeOne(item) {
  if (!item || typeof item !== "object" || !item.provider) return null;
  return {
    provider: String(item.provider),
    providerLabel: item.providerLabel ? String(item.providerLabel) : String(item.provider),
    detail: item.detail ? String(item.detail) : "",
    openedAt: toNum(item.openedAt),
    blockedUntil: toNum(item.blockedUntil),
    blocking: item.blocking == null ? true : Boolean(item.blocking),
    affectedConfigurations: Array.isArray(item.affectedConfigurations)
      ? item.affectedConfigurations
          .filter((c) => c && Number.isInteger(Number(c.id)))
          .map((c) => ({ id: Number(c.id), name: String(c.name || `#${c.id}`) }))
      : [],
  };
}

export function normalizeItems(items) {
  if (!Array.isArray(items)) return [];
  return items.map(normalizeOne).filter(Boolean);
}

export function applyHealthEvent(alerts, event) {
  if (!event || typeof event !== "object" || !event.provider) return alerts;
  if (event.status === "recovered") {
    const next = alerts.filter((a) => a.provider !== event.provider);
    return next.length === alerts.length ? alerts : next;
  }
  if (event.status !== "billing") return alerts;

  const incoming = normalizeOne(event);
  if (!incoming) return alerts;
  const idx = alerts.findIndex((a) => a.provider === incoming.provider);
  if (idx === -1) return [...alerts, incoming];
  const merged = {
    ...alerts[idx],
    ...incoming,
    detail: incoming.detail || alerts[idx].detail,
    affectedConfigurations:
      incoming.affectedConfigurations.length > 0 ? incoming.affectedConfigurations : alerts[idx].affectedConfigurations,
  };
  const next = alerts.slice();
  next[idx] = merged;
  return next;
}

export function dismissKey(companyId, alert) {
  return `ai-health-dismissed:${companyId}:${alert.provider}:${alert.openedAt}`;
}

export function isDismissed(storage, companyId, alert) {
  try {
    return storage.getItem(dismissKey(companyId, alert)) === "1";
  } catch (e) {
    return false;
  }
}

export function visibleAlerts(alerts, storage, companyId) {
  return alerts.filter((a) => !isDismissed(storage, companyId, a));
}
